import mapBTMPlanName from 'utils/pivot/plan/mapBTMPlanName'
import { PRODUCT_BTM } from 'core/constants/environment'
import getResourceFromV2 from 'core/services/getResourceFromV2'

async function getBTMBenefits(plan: ComparePage.Plan): ComparePage.PlanTableCellConfig[] {
  const benefits = []
  const summaryNameBase = mapBTMPlanName(plan).toLowerCase()
  const path = `products/${PRODUCT_BTM}/details/${summaryNameBase}`

  const benefitsArray = await (summaryNameBase
    ? getResourceFromV2(`${path}-summary.json`)
    : Promise.resolve([]))
  const parsedBenefits = benefitsArray.map(
    (benefit: { headline: string; body: string[] }): ComparePage.PlanTableCellConfig => {
      return {
        title: benefit.headline,
        primaryValue: benefit.body
          .join(' ')
          .replace('/', ' / ')
          .replace('.', '\n.'),
        underlined: true
      }
    }
  )

  benefits.push(...parsedBenefits)
  return benefits
}

export default getBTMBenefits
